// extracted by mini-css-extract-plugin
export default {"container":"container--_CBff","hovered":"hovered--_cik_","removeWrapper":"removeWrapper--H9FZV","remove":"remove--d01YZ"};